module.exports = __webpack_public_path__ + "static/media/img14.e1e827aa.jpg";